import styled from 'styled-components';
import { Button, Segment, Text } from '@playbookux/playbook-web-core';
import { Image } from 'semantic-ui-react';

export const ServiceContainer = styled(Segment)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  &&& {
    margin-top: 1rem;
  }
`;
export const ServiceIcon = styled(Image)`
  &&&{
    width: 50px;
    margin: 0;
  }
`;

export const ServiceIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

export const ServiceListItem = styled.li`
  margin-left: 14px;
`;

export const ConnectButton = styled(Button)`
  `;

export const DisconnectButton = styled(Button)`
  &&&& {
    background-color: #ec4b4c;
  }
`;

export const ServiceName = styled(Text.Header)`
  font-size: 1rem;
`;

export const ServiceDescriptionList = styled.ul``;

export const FlexContainer = styled.div`
  display: flex;
  gap: 20px;
`;
